import { Api } from "../../lib";
import { authClient, hasDirectorPermissions, uiActions } from "../states";
import { AppThunk } from "../types";
import { serviceRequests } from "./state";
import { ServiceRequest } from "./types";
const { actions } = serviceRequests;

export const serviceRequestsActions = {
  submitServiceRequest(values: ServiceRequest, files: FormData): AppThunk {
    return async (dispatch) => {
      dispatch(uiActions.setLoading(true));
      const { status, data } = await Api.post(`/service-request`, values);
      if (status === 200) {
        const { uuid } = data;
        // set uuid in state
        dispatch(actions.setServiceRequestUUID(uuid));
        // check if FormData is not empty and has file
        if (files && files.get("file")) {
          dispatch(
            serviceRequestsActions.uploadServiceRequestFiles(uuid, files),
          );
        }
        dispatch(
          uiActions.showSuccess("Service request submitted successfully"),
        );
      } else {
        dispatch(uiActions.showError("Failed to submit service request"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
  uploadServiceRequestFiles(uuid: string, files: FormData): AppThunk {
    return async (dispatch) => {
      dispatch(uiActions.setLoading(true));
      const { status } = await Api.post(
        `/service-request/${uuid}/files`,
        files,
      );
      if (status === 204) {
        dispatch(uiActions.showSuccess("Files uploaded successfully"));
      } else {
        dispatch(uiActions.showError("Failed to upload files"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
  // get list of service requests
  getServiceRequests(
    role: string | undefined,
    agency_id?: number | undefined,
  ): AppThunk {
    return async (dispatch) => {
      if (!role) {
        throw new Error("Role needed to retrieve quotes for agent");
      }
      const url = hasDirectorPermissions(role)
        ? `/service-requests`
        : `/service-requests/agency/${agency_id}`;
      dispatch(uiActions.setLoading(true));
      const { status, data } = await authClient.get(url);
      if (status === 200) {
        dispatch(actions.setServiceRequests(data));
      } else {
        dispatch(uiActions.showError("Failed to get service requests"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
  getServiceRequestByUUID(uuid: string): AppThunk {
    return async (dispatch) => {
      dispatch(uiActions.setLoading(true));
      const { status, data } = await authClient.get(`/service-request/${uuid}`);
      if (status === 200) {
        dispatch(actions.setServiceRequest(data));
      } else {
        dispatch(uiActions.showError("Failed to get service request"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
  // Send email to client or update status
  updateServiceRequest(
    uuid: string,
    data: {
      status?: string;
      subject?: string;
      message?: string;
    },
  ): AppThunk {
    return async (dispatch) => {
      dispatch(uiActions.setLoading(true));
      const { status: responseStatus } = await authClient.put(
        `/service-request/${uuid}/update`,
        data,
      );
      if (responseStatus === 204) {
        // If status was updated, refresh the service request data
        if (data.status) {
          dispatch(serviceRequestsActions.getServiceRequestByUUID(uuid));
        }
        dispatch(uiActions.showSuccess("Request updated successfully"));
      } else {
        dispatch(uiActions.showError("Failed to update request"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
  clientUpdateServiceRequest(
    uuid: string,
    message: string,
    files: FormData,
  ): AppThunk {
    return async (dispatch) => {
      dispatch(uiActions.setLoading(true));
      const { status } = await Api.put(
        `/client/service-request/${uuid}/update`,
        { message },
      );
      if (files && files.get("file")) {
        dispatch(
          serviceRequestsActions.uploadServiceRequestFiles(uuid, files),
        );
      }
      if (status === 204) {
        dispatch(uiActions.showSuccess("Request updated successfully"));
      } else {
        dispatch(uiActions.showError("Failed to update request"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
  getServiceRequestStatus(uuid: string): AppThunk {
    return async (dispatch) => {
      dispatch(uiActions.setLoading(true));
      const { status, data } = await Api.get(`/service-request/${uuid}/status`);
      if (status === 200) {
        dispatch(actions.setServiceRequestStatus(data.status));
      } else {
        dispatch(uiActions.showError("Failed to get request status"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
  assignServiceRequestToDirector(uuid: string, director_id: any): AppThunk {
    return async (dispatch) => {
      dispatch(uiActions.setLoading(true));
      const { status } = await authClient.put(`/service-request/${uuid}/assign`, { director_id });
      if (status === 204) {
        dispatch(serviceRequestsActions.getServiceRequestByUUID(uuid));
        dispatch(uiActions.showSuccess("Request assigned successfully"));
      } else {
        dispatch(uiActions.showError("Failed to assign request"));
      }
      dispatch(uiActions.setLoading(false));
    };
  },
};

